import { DatePicker, Select } from 'antd';
import moment from 'moment';
import QueryString from 'qs';
import { FC, useEffect, useState } from 'react';
import { CgCloseR } from 'react-icons/cg';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getSubjects2 } from '../../../api/notification.api';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetSubjects, INotification } from '../../../models/notification.model';
import { RootState } from '../../../store/rootReducer';
import Button from '../../Button';
import ErrorResponse from '../../ErrorResponse';
import FileUpload from '../../FileUpload';
import Loader from '../../Loader';
import Radio from '../../Radio';
import useUtil from '../../../hooks/useUtil';
import { IGetTimetables } from '../../../models/campusClasses3.model';
import { getTimetables } from '../../../api/campusClasses3.api';
import CustomTimePicker from '../../CustomTimePicker';

interface IProps {
  event: any;
  submit: (data: FormData) => void;
  toSubmit: boolean;
  setToSubmit: (toSubmit: boolean) => void;
  data?: INotification|undefined;
  isTutor?: boolean;
  className?: string|undefined;
}

const NoticeEditor2: FC<IProps> = ({
  event,
  submit,
  toSubmit,
  setToSubmit,
  data,
  isTutor = false,
  className,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const query = QueryString.parse(location.search, { ignoreQueryPrefix: true });
  const classCode = String(query.classCode);
  const { auth } = useSelector((state: RootState) => state.auth);
  const { chosenClass } = useSelector((state: RootState) => state.class);
  const { infoNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetSubjects>();
  const { data: res2, isLoading : isLoading2, error : error2, execute : execute2 } = useAxios<IGetTimetables>();
  const { getCommonCodeLabel } = useUtil();
  
  const [classTimeSeq, setClassTimeSeq] = useState<number>();
  const [subjectCode, setSubjectCode] = useState<number>();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [alarmYN, setAlarmYN] = useState('Y');
  const [files, setFiles] = useState<any>([null]);
  const [isCreate, setIsCreate] = useState(true);
  const [sms, setSms] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState<any>();
  const [noticeType, setNoticeType] = useState<string>();
  const [dueDate, setDueDate] = useState<string>();
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // NT0001 = 알림장 타입
  const NT0001 = commonCodes.find(item => item.commonCode === 'NT0001')?.detailCode;
  const lTimetables = res2?.data;
  const [resvYn, setResvYn] = useState('');
  const [oriResvYn, setOriResvYn] = useState('');
  const [resvDateTime, setResvDateTime] = useState('');
  const [disableSendTime, setDisableSendTime] = useState<any>(false) ;
  
  useEffect(() => {
    if (chosenClass?.classCode) {
      execute2(getTimetables(chosenClass.classCode));            
    }
  }, [])

  useEffect(() => {
    if (event) {
      execute(getSubjects2({
        semesterCourseCode: event.resource.semesterCourseCode,
        timetableSeq: event.resource.timetableSeq,
        timetableCode: event.resource.timetableCode,
      }));

      const todayDate = moment(new Date()).format('YYYY-MM-DD');
      if(moment(event?.start) < moment(todayDate) || moment(event?.start) > moment(todayDate).add(30, 'days')) {
          setDisableSendTime(true);
      } else {
          setDisableSendTime(false);
      }
    }
  }, [event]);

  useEffect(() => {
    if (data) {
      setClassTimeSeq(data.classTimeSeq);
      setSubjectCode(data.subjectCode);
      setTitle(data.title);
      setContent(data.content);
      setAlarmYN(data.alarmYN);
      setAttachedFiles(data.files);
      setNoticeType(data.noticeType);
      setDueDate(data.dueDate);
      setSms(data.onlySmsYn === 'Y' ? true : false);
      setIsCreate(false);

      if(data.resvYn) {
        setResvYn(data.resvYn);
        setOriResvYn(data.resvYn);
      } else {
        setResvYn('N');
        setOriResvYn('N');
      }

      if(data.resvDateTime) {
        const tempTime = moment(data.resvDateTime).format('HH:mm');
        setResvDateTime(tempTime);
      } else {
        setResvDateTime('');
      }
      
    }
  }, [data]);

  useEffect(() => {
    if (toSubmit) {
      handleSubmit();
    }
  }, [toSubmit]);

  const onSetFile = (index: number, file: any) => {
    const _files = [...files];
    _files[index] = file;
    setFiles(_files);
  }

  const onAddFile = () => {
    const _files = [...files];
    _files.push(null);
    setFiles(_files);
  }

  const onDeleteFile = (index: number) => {
    const _files = [...files];
    _files.splice(index, 1);
    setFiles(_files);
  }

  const onDeleteAttachedFile = (index: number) => {
    const _attachedFiles = [...attachedFiles];
    _attachedFiles[index].originalName = null;
    setAttachedFiles(_attachedFiles);
  }

  const handleSubmit = () => {
    setToSubmit(false);
    if ((!isTutor && !chosenClass) || !event) return;
    /*
    if (!subjectCode) {
      return infoNotification(t('class.class.message29'));
    }
      */
    if (!title) {
      return infoNotification(t('class.class.message30'));
    }
    if (!content) {
      return infoNotification(t('class.class.message31'));
    }
    //발송시간유형 체크
    if(oriResvYn === 'Y') {
      if(!resvYn) {
        return infoNotification(t('class.notice.message4'));
      } else if(resvYn === 'Y' && !resvDateTime) {
        return infoNotification(t('class.notice.message5'));
      } else if(resvYn === 'Y' && resvDateTime) {
        const now = new Date();
        const tempResvDateTime = new Date( String(moment(event?.start).format('YYYY-MM-DD') + ' ' + resvDateTime + ':00'));
        if (tempResvDateTime < now) {
          return infoNotification(t('class.notice.message9'));
        }
      }
    }
    const formData = new FormData();
    // @ts-ignore
    formData.append('classCode', isTutor ? classCode : chosenClass.classCode);
    formData.append('timetableCode', event.resource.timetableCode);
    formData.append('title', title);
    formData.append('content', content);
    formData.append('alarmYN', alarmYN);
    if (isCreate) {
      formData.append('classTimeSeq', String(classTimeSeq));
      formData.append('subjectCode', String(subjectCode));
      formData.append('sms', String(sms));
    }
    formData.append('dueDate', String(dueDate));
    formData.append('oriResvYn', String(oriResvYn));
    formData.append('resvYn', String(resvYn));
    if(resvYn === 'Y') {
      formData.append('resvDateTime', String(moment(event?.start).format('YYYY-MM-DD') + ' ' + resvDateTime + ':00'));
    }

    let isAllDeleted = true;

    if (isCreate) {
      /* 생성 시 파일 처리 */
      if (files.length > 0) {
        files.forEach((item: any) => {
          if (item !== null) {
            formData.append('files', item);
          }
        });
      }
    } else {
      /* 수정 시 파일 처리 */
      if (data?.attachFileCode) {
        formData.append('attachFileCode', String(data.attachFileCode));
      }

      if (attachedFiles) {
        // 기존 첨부파일 있음
        let hasNewFiles = false;
        files.forEach((item: any) => {
          if (item) hasNewFiles = true;
        });

        let hasDeleted = false;
        attachedFiles.forEach((item: any) => {
          if (item.originalName) {
            isAllDeleted = false;
          } else {
            hasDeleted = true;
            formData.append('deleteFile', item.fileSeq);
          }
        });

        if (hasNewFiles) formData.append('fileStatus', 'update');
        else if (isAllDeleted) formData.append('fileStatus', 'delete');
        else if (hasDeleted) formData.append('fileStatus', 'update');
        else formData.append('fileStatus', 'keep');
      } else {
        // 기존 첨부파일 없음
        if (files.length > 0 && files[0] !== null) {
          // 추가 첨부파일 있음
          formData.append('fileStatus', 'create');
        } else {
          // 추가 첨부파일 없음
          formData.append('fileStatus', 'keep');
        }
      }

      if (files.length > 0) {
        files.forEach((item: any) => {
          if (item !== null) {
            formData.append('newFiles', item);
          }
        });
      }
    }

    submit(formData);
  }

  const disabledHours = () => {
      const sendDate = moment(event?.start).format('YYYY-MM-DD');
      const currentDate = moment(new Date());
      const hourArray = Array.from({ length: 24 }, (v, k) => k);
      if (sendDate === currentDate.format('YYYY-MM-DD')) {
          return hourArray.filter((v) => v < currentDate.hour());
      } else {
          return [];
      }
  };

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <div className='comm-table__area rowType edit mt-0'>
        <table>
          <colgroup>
            <col width="150px" />
            <col width="200px" />
            <col width="*" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th className="text-center">{t('class.class.column89')}</th>
              <td>
                {
                  isCreate
                    ? moment(event?.start).format('YYYY.MM.DD')
                    : moment(data?.timetableDate).format('YYYY.MM.DD')
                }
              </td>
              <th className="text-center">{t('class.class.column87')}</th>
              <td>
                {getCommonCodeLabel('PR0006', chosenClass?.eduStepCode)}
              </td>
            </tr>
            <tr>
              <th className="text-center">{t('class.class.column57')}</th>
              <td colSpan={3}>
                {
                  isCreate
                    ? isTutor ? className : chosenClass?.className
                    : data?.className
                }
              </td>
            </tr>
            <tr>
              <th className="text-center">{t('statistics.homework.column4')}</th>
              <td>
                <div className="w-150p">
                  <Select
                      className="w-100"
                      placeholder={t('common.button.select')}
                      value={noticeType}
                      disabled={true}
                  >
                      {
                          NT0001?.map((item: any) => {
                              return (
                                <Select.Option
                                  key={item.detailCode}
                                  value={item.detailCode}
                                >
                                  {item.korName}
                                </Select.Option>
                              )
                          })
                      }
                  </Select>
                </div>
              </td>
              <th className="text-center">{t('class.class.column90')}</th>
              <td>
                <div className="w-150p">
                  <Select
                    className="w-100"
                    placeholder={t('common.button.select')}
                    value={subjectCode}
                    onChange={(value) => {
                      const _classTimeSeq = res?.data?.find(item => item.subjectCode === value)?.classTimeSeq;
                      setClassTimeSeq(_classTimeSeq);
                      setSubjectCode(value);
                    }}
                    disabled={!isCreate}
                  >
                    {res?.data.map((item) => (
                      <Select.Option
                        key={item.subjectCode}
                        value={item.subjectCode}
                      >
                        {item.subjectName}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
              </td>
            </tr>
            <tr>
              <th className="text-center">{t('class.class.column91')}</th>
              <td colSpan={3}>
                <input
                  type="text"
                  className="form-control"
                  value={title}
                  onChange={e => setTitle(e.target.value)}
                />
              </td>
            </tr>
            <tr>
              <th className="text-center">{t('class.class.column92')}</th>
              <td colSpan={3}>
                <textarea
                  rows={3}
                  value={content}
                  onChange={e => setContent(e.target.value)}
                />
              </td>
            </tr>
            <tr>
                <th className="text-center">{t('class.notice.duedate')}</th>
                <td colSpan={3}>
                  <div className="date-picker__area">
                    <DatePicker
                        value={dueDate ? moment(dueDate) : moment()}
                        onChange={(e) => {
                            if (e === null) {
                                setDueDate('');
                            } else {
                                setDueDate(moment(e).format('YYYYMMDD'));
                            }
                        }}
                        format={['YYYY-MM-DD', 'YYYYMMDD']}
                        disabledDate={current => {
                            if(noticeType === 'HW') {
                                const timetable = lTimetables?.find(item => item.srtDate === moment(current).format('YYYYMMDD'));
                                return timetable ? false : true;
                            } else {
                                return false;
                            }
                        }}
                    />
                  </div>
                </td>
            </tr>
            {
              attachedFiles?.length
                ? (
                  <tr>
                    <th className="text-center">{t('archive.learn.column5')}</th>
                    <td colSpan={3}>
                      {
                        attachedFiles.map((item: any, index: number) => {
                          return item?.originalName
                            ? (
                              <div>
                                <a
                                  className="download-link"
                                  href={`${item.fileLocation}`}
                                  download={item.originalName}
                                >
                                  {item.originalName}
                                </a>
                                <span
                                  className="ml-1 pointer"
                                  onClick={() => onDeleteAttachedFile(index)}
                                >
                                  <CgCloseR />
                                </span>
                              </div>
                            )
                            : null;
                        })
                      }
                    </td>
                  </tr>
                  )
                : null
            }
            <tr>
              <th className="text-center">{t('archive.exam.column7')}</th>
              <td colSpan={3}>
                {
                  files.length > 0
                    ? files.map((file: any, index: number) => (
                      <div className="flex mb-2" key={index}>
                        <FileUpload
                          file={files[index]}
                          setFile={(file: any) => onSetFile(index, file)}
                        />
                        <div className="comm-btn__area">
                          <Button
                            className="btn-basic small gray ml-2"
                            onClick={() => onDeleteFile(index)}
                            text={t('common.button.delete')}
                          />
                        </div>
                      </div>
                    ))
                    : null
                }
                <div className="comm-btn__area">
                  <Button
                    className="btn-basic pink-line"
                    onClick={onAddFile}
                    text={t('common.button.add')}
                  />              
                </div>
              </td>
            </tr>
            <tr>
              <th className="text-center">{t('class.class.column94')}</th>
              <td className="pl-4">
                <Radio
                  checked={alarmYN === 'Y'}
                  onChange={() => setAlarmYN('Y')}
                  text={t('common.option.yes')}
                  disabled={!isCreate}
                />
                <Radio
                  className="ml-4"
                  checked={alarmYN === 'N'}
                  onChange={() => setAlarmYN('N')}
                  text={t('common.option.no')}
                  disabled={!isCreate}
                />
              </td>
              <th className="text-center">{t('class.class.column95')}</th>
              <td className="pl-4" colSpan={3}>
                <Radio
                  checked={!sms}
                  onChange={() => setSms(false)}
                  text={t('class.class.option4')}
                  disabled={!isCreate}
                />
                <Radio
                  className="ml-4"
                  checked={sms}
                  onChange={() => setSms(true)}
                  text={t('class.class.option5')}
                  disabled={!isCreate}
                />
              </td>
            </tr>
            {oriResvYn === 'Y' &&
            <tr>
              <th className="text-center">{t('class.notice.label2')}</th>
              <td className="pl-4" colSpan={3}>
                <div className='comm-gap'>
                    <Radio
                        checked={resvYn==='N'}
                        onChange={() => {
                            setResvYn('N');
                        }}
                        text={t('class.notice.label3')}
                        disabled={disableSendTime}
                    />
                    <Radio
                        className="ml-4"
                        checked={resvYn==='Y'}
                        onChange={() => {
                            setResvYn('Y');
                        }}
                        text={t('class.notice.label4')}
                        disabled={disableSendTime}
                    />
                    <input type="text" className="form-control w-90p ml-3" value={moment(event?.start).format('YYYY.MM.DD')} disabled={true} />
                    <div className="time-picker__area">
                        <CustomTimePicker
                            value={resvDateTime}
                            onSelect={(value) => {
                                if (value) {
                                    setResvDateTime(moment(value).format('HH:mm'));
                                } else {
                                    setResvDateTime('');
                                }                       
                            }}
                            minuteStep={30}
                            disabledHours={disabledHours}
                            disabled={disableSendTime}
                        />
                    </div>
                </div>
                {resvYn==='Y' &&
                    <div className="mt-2 notice-high">
                        {t('class.notice.message6')}<br/>
                        {t('class.notice.message7')}<br/>
                        {t('class.notice.message8')}
                    </div>
                }
                {(resvYn==='N' && disableSendTime) &&
                    <div className="mt-2 notice-high">
                        {t('class.notice.message6')}<br/>
                    </div>
                }
              </td>
            </tr>
            }
            <tr>
              <th className="text-center">{t('class.class.column93')}</th>
              <td colSpan={3}>
                {
                  isCreate
                    ? auth?.korName
                    : data?.writerMemberName
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default NoticeEditor2;
